import type { EntityConfigDefinition, DisplayColumnConfig } from '../../types/entityConfig'
import { TABLE_SERVICE_PROVIDER } from '../../utils/displayFormatters'

const config: EntityConfigDefinition = {
  name: 'SERVICE_DOMAIN',
  idField: 'SERVICE_DOMAIN_ID',
  
  // Data loading configuration
  loadServiceProviders: true,
  
  // Use optimized list query with SERVICE_PROVIDER join to eliminate multiple API calls
  useOptimizedQuery: true,
  optimizedQueryName: 'listServiceDomainsWithProvider',
  supportsPagination: true,
  
  // Foreign key configuration for table display
  foreignKeys: {
    SERVICE_PROVIDER_ID: {
      table: 'SERVICE_PROVIDER',
      valueField: 'SERVICE_PROVIDER_ID',
      displayField: 'SERVICE_PROVIDER_NAME'
    }
  },
  
  // Form processing configuration
  keepAuditFieldsOnUpdate: false,
  
  // Environment copy configuration
  preserveOnCopy: ['SERVICE_DOMAIN_ID'],
  
  // Field lookups for display enhancement
  fieldLookups: {
    SERVICE_PROVIDER_ID: {
      lookupTable: 'SERVICE_PROVIDER',
      foreignKey: 'SERVICE_PROVIDER_ID',
      displayField: 'SERVICE_PROVIDER_NAME',
      displayFormat: TABLE_SERVICE_PROVIDER
    }
  },
  
  // Foreign key auto-creation configuration
  autoCreateForeignKeys: {
    SERVICE_PROVIDER_ID: {
      entity: 'SERVICE_PROVIDER',
      matchFields: ['SERVICE_PROVIDER_NAME'],
      copyFields: ['SERVICE_PROVIDER_NAME', 'CREATED_BY_USER_ID', 'CREATED_DATE']
    }
  },
  
  // Fields to remove before GraphQL mutations
  fieldsToRemove: ['SERVICE_PROVIDER_ID_DISPLAY', 'SERVICE_PROVIDER_NAME', 'CREATED_BY_USER_ID'],
  
  // Environment comparison configuration
  comparisonConfig: {
    matchingFields: ['DOMAIN_URL'],
    comparisonFields: ['DOMAIN_URL', 'SERVICE_PROVIDER_ID'],
    stringMatchFields: ['DOMAIN_URL'],
    stringMatchThreshold: 0.50,
    useDisplayValues: {
      'SERVICE_PROVIDER_ID': 'SERVICE_PROVIDER_NAME'
    },
    displayFieldMapping: {
      SERVICE_PROVIDER_ID: 'SERVICE_PROVIDER_NAME'
    },
    displayFields: ['SERVICE_DOMAIN_ID', 'DOMAIN_URL', 'SERVICE_PROVIDER_ID', 'CREATED_DATE', 'CHANGED_DATE'],
    resolveLookupsForBothEnvironments: true
  },
  
  // Display columns with foreign key lookups
  displayColumns: [
    {
      field: 'SERVICE_PROVIDER_ID',
      lookup: {
        table: 'SERVICE_PROVIDER',
        foreignKey: 'SERVICE_PROVIDER_ID',
        displayField: 'SERVICE_PROVIDER_NAME'
      }
    }
  ] as DisplayColumnConfig[],

  // Fields configuration
  fields: [
    "SERVICE_DOMAIN_ID",
    "DOMAIN_URL",
    "SERVICE_PROVIDER_ID",
    "CREATED_DATE",
    "CHANGED_DATE"
  ],
  
  // Form fields configuration
  formFields: [
    {
      name: "DOMAIN_URL",
      type: "text",
      required: false,
      disabled: false
    },
    {
      name: "SERVICE_PROVIDER_ID",
      type: "select",
      required: true,
      disabled: false
    },
    {
      name: "CREATED_DATE",
      type: "text",
      required: false,
      disabled: true
    },
    {
      name: "CHANGED_DATE",
      type: "text",
      required: false,
      disabled: true
    }
  ]
}

export default config
